import React from 'react'

import clsx from 'clsx'

import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Rating from 'components/Rating'
import Typography from 'components/Typography'

import { roundToOneDecimal } from '../../helpers'
import DeltaChange from '../DeltaChange'
import PricingDetails from '../PricingDetails'
import ProductTag from '../ProductTag'
import TopFeatures from '../TopFeatures'

import classes from './DesktopContent.module.scss'

const DesktopContent = ({ listing, alternative }) => {
  const listingHasReviews = listing.num_reviews > 0
  return (
    <div className={clsx(classes.root, classes.background)}>
      <div className={clsx(classes.item, classes.itemLeft, classes.heading)}>
        <ProductTag listing={alternative} />
      </div>
      <div></div>
      <div className={clsx(classes.item, classes.itemRight, classes.heading)}>
        <ProductTag listing={listing} />
      </div>
      {/* Value for money */}
      <div className={clsx(classes.item, classes.itemLeft)}>
        {listingHasReviews && (
          <DeltaChange
            className={classes.deltaChange}
            listingRating={roundToOneDecimal(listing.by_field.rating_value)}
            alternativeRating={roundToOneDecimal(alternative.by_field.rating_value)}
          />
        )}
        <Rating.Base average={alternative.by_field.rating_value} isCompact size="small" className={classes.rating} />
      </div>
      <div className={clsx(classes.item, classes.itemCenter)}>
        <Typography variant="heading-xs">Value for money</Typography>
      </div>
      <div className={clsx(classes.item, classes.itemRight)}>
        <Rating.Base average={listing.by_field.rating_value} isCompact size="small" className={classes.rating} />
      </div>
      {/* Starting price */}
      <div className={clsx(classes.item, classes.itemLeft)}>
        <PricingDetails pricing={alternative.pricing} align="right" />
      </div>
      <div className={clsx(classes.item, classes.itemCenter)}>
        <InfoCircleTooltip
          className={classes.infoCircle}
          label={<Typography variant="heading-xs">Starting price</Typography>}
          title="Prices may vary depending on the number of users and features."
        />
      </div>
      <div className={clsx(classes.item, classes.itemRight)}>
        <PricingDetails pricing={listing.pricing} align="left" />
      </div>
      {/* Functionality */}
      <div className={clsx(classes.item, classes.itemLeft)}>
        {listingHasReviews && (
          <DeltaChange
            className={classes.deltaChange}
            listingRating={roundToOneDecimal(listing.by_field.rating_features)}
            alternativeRating={roundToOneDecimal(alternative.by_field.rating_features)}
          />
        )}
        <Rating.Base average={alternative.by_field.rating_features} isCompact size="small" className={classes.rating} />
      </div>
      <div className={clsx(classes.item, classes.itemCenter)}>
        <Typography variant="heading-xs">Functionality</Typography>
      </div>
      <div className={clsx(classes.item, classes.itemRight)}>
        <Rating.Base average={listing.by_field.rating_features} isCompact size="small" className={classes.rating} />
      </div>
      {/* Top Features */}
      <div className={clsx(classes.item, classes.itemLeft)}>
        <TopFeatures listing={alternative} uniqueFeatures={alternative.features.unique.alt} align="right" />
      </div>
      <div className={clsx(classes.item, classes.itemCenter)}>
        <Typography variant="heading-xs">Top Features</Typography>
      </div>
      <div className={clsx(classes.item, classes.itemRight)}>
        <TopFeatures listing={listing} uniqueFeatures={alternative.features.unique.main} align="left" />
      </div>
    </div>
  )
}

export default DesktopContent
